var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('goodPtw',{attrs:{"isShow":_vm.showPtw,"parames":_vm.ptwParams},on:{"close":_vm.handlePtwClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }